exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.parent[data-v-5c84940c] {\n  min-height: 2px;\n}\n.parent .meter[data-v-5c84940c] {\n    -ms-flex: 4;\n        flex: 4;\n    height: 4px;\n    border-radius: 2px;\n    min-height: 2px;\n}\n.parent .meter > span[data-v-5c84940c] {\n      width: 0%;\n      height: 4px;\n      border-radius: 2px;\n      min-height: 2px;\n}\n.parent .event[data-v-5c84940c] {\n    min-height: 2px;\n    width: 100%;\n}\n.parent .event .spaced[data-v-5c84940c] {\n      margin: 1rem 0.5rem 0 1.75rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5c84940c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/calendar/EventMeter.vue
// module id = 2636
// module chunks = 0